import { ClassAttributes, HTMLAttributes } from "react";
import { Interpolation, Theme, css, useTheme } from "@emotion/react";

export const Separator = ({
  ...props
}: ClassAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & { css?: Interpolation<Theme> }) => {
  const theme = useTheme();

  return (
    <div
      css={css`
        width: 100%;
        height: 12.25px;
        border-top: 1.75px solid ${theme.palette.line};
        background-color: ${(theme as any).mode === "dark"
          ? theme.palette.grey[50]
          : theme.palette.grey[100]};
      `}
      {...props}
    />
  );
};
